import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Card} from '../card/card';
import {LinkCard} from '../card/link-card';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {StatusBadge} from '../status-badge/status-badge';
import type {Level} from '../status-badge/status-badge';
import {Body} from '../typography/body';

import styles from './settings-card.module.css';

type Props = {
    header: string;
    body: string | null | undefined;
    extraInfo?: React.ReactNode;
    action: string | null | undefined;
    to: string;
    status: {
        level: Level;
        text: string;
    };
    isDisabled: boolean;
};

export function SettingsCard(props: Props) {
    const Tag = props.isDisabled ? Card : LinkCard;

    return (
        <div
            className={
                props.isDisabled ? styles['settings-card--disabled'] : styles['settings-card']
            }
        >
            <Tag
                // @ts-expect-error
                as={RoutedLink}
                hasBorder={true}
                hasShadow={false}
                to={props.to}
                preventUnderline={true}
            >
                <div className={styles.container}>
                    <StackLegacy spacing={16}>
                        <Body isBold={true} size='large'>
                            {props.header}
                        </Body>
                        {props.body && <Body>{props.body}</Body>}
                        {props.extraInfo}
                        <StatusBadge {...props.status} />
                    </StackLegacy>
                    <div className={styles.action}>
                        <Body as='div' color='blue'>
                            {props.action}
                        </Body>
                    </div>
                </div>
            </Tag>
        </div>
    );
}
